import React, { useState } from "react";
import { Box, Checkbox, Flex, Input, Select, Text } from "@chakra-ui/react";
import { FaChevronDown, FaChevronRight, FaPencilAlt, FaPlus, FaTrash } from "react-icons/fa";
import axios from "axios";
import { API_URL } from "../config";
import { getToken } from "../token";
import { FORUM, TRANSITION } from "../Theme/styles";
import { CATEGORIES, findCategory } from "../categories";
import { isRcon } from "../permissions";
import { myId } from "../permissions";

const STATUS_NAME = {
  do_realizacji: "Do realizacji",
  w_trakcie: "W trakcie",
  do_sprawdzenia: "Do sprawdzenia",
  do_poprawy: "Do poprawy",
  ukonczone: "Ukończone",
};

const AssignmentSection = ({ assignment, people, moje, canManage, onChange }) => {
  const [expanded, setRozwiniete] = useState(moje);
  const [draft, setNowa] = useState("");
  const [adding, setDodaje] = useState(false);
  const [error, setError] = useState(null);
  const [editedItem, setEditedItem] = useState(null);
  const [draftItem, setDraftItem] = useState("");

  const header = findCategory(assignment.team)?.name || assignment.team;
  const person =
    assignment.kind === "person"
      ? people.find((o) => o.id === assignment.assigned_to)
      : null;

  const claimedBy = assignment.claimed_by
    ? people.find((o) => String(o.id) === String(assignment.claimed_by))
    : null;
  const claimedByMe = String(assignment.claimed_by) === String(myId());

  const done_all = assignment.items.filter((p) => p.done).length;
  const wszystkie = assignment.items.length;
  const headers = { Authorization: `Bearer ${getToken()}` };

  const toggle = (item, done) =>
    axios
      .put(`${API_URL}/subtasks/${item.id}`, { done }, { withCredentials: true, headers: headers })
      .then(onChange)
      .catch((e) => console.error("Nie udało się zmienić pozycji", e));

  const renameItem = (item, tekst) => {
    const body = tekst.trim();
    if (!body || body === item.description) {
      setEditedItem(null);
      return;
    }
    axios
      .put(
        `${API_URL}/subtasks/${item.id}`,
        { description: body },
        { withCredentials: true, headers: headers }
      )
      .then(() => {
        setEditedItem(null);
        onChange();
      })
      .catch((e) => setError(e?.response?.data?.error || "Nie udało się zmienić pozycji"));
  };

  const remove = (item) =>
    axios
      .delete(`${API_URL}/subtasks/${item.id}`, { withCredentials: true, headers: headers })
      .then(onChange)
      .catch((e) => console.error("Nie udało się usunąć pozycji", e));

  const claim = () =>
    axios
      .post(`${API_URL}/assignments/${assignment.id}/claim`, {}, { withCredentials: true, headers: headers })
      .then(onChange)
      .catch((e) => console.error("Nie udało się wziąć zadania", e));

  const release = () =>
    axios
      .delete(`${API_URL}/assignments/${assignment.id}/claim`, { withCredentials: true, headers: headers })
      .then(onChange)
      .catch((e) => console.error("Nie udało się oddać zadania", e));

  const setAssignee = (id) => {
    setError(null);
    axios
      .put(
        `${API_URL}/assignments/${assignment.id}/assignee`,
        { assigned_to: id || null },
        { withCredentials: true, headers }
      )
      .then(onChange)
      .catch((e) => setError(e?.response?.data?.error || "Nie udało się zmienić osoby"));
  };

  const removeAssignment = () =>
    axios
      .delete(`${API_URL}/assignments/${assignment.id}`, { withCredentials: true, headers })
      .then(onChange)
      .catch((e) => console.error("Nie udało się usunąć przydziału", e));

  const moveToCategory = (team) => {
    setError(null);
    axios
      .put(
        `${API_URL}/assignments/${assignment.id}/team`,
        { team },
        { withCredentials: true, headers }
      )
      .then(onChange)
      .catch((e) => setError(e?.response?.data?.error || "Nie udało się przenieść"));
  };

  const setDeadline = (data) =>
    axios
      .put(
        `${API_URL}/assignments/${assignment.id}/deadline`,
        { deadline: data || null },
        { withCredentials: true, headers: headers }
      )
      .then(onChange)
      .catch((e) => console.error("Nie udało się ustawić terminu", e));

  const add = () => {
    const body = draft.trim();
    if (!body || adding) return;
    setDodaje(true);
    axios
      .post(
        `${API_URL}/subtasks`,
        { assignment_id: assignment.id, description: body },
        { withCredentials: true, headers: headers }
      )
      .then(() => {
        setNowa("");
        return onChange();
      })
      .catch((e) => console.error("Nie udało się dodać pozycji", e))
      .finally(() => setDodaje(false));
  };

  return (
    <Box
      border={"1px solid"}
      borderColor={moje ? "rgba(108,153,255,0.35)" : FORUM.obramowanie}
      bg={FORUM.tlo}
      borderRadius={"md"}
      mb={2}
    >
      <Flex
        align={"center"}
        gap={2}
        px={3}
        py={2}
        cursor={"pointer"}
        onClick={() => setRozwiniete((r) => !r)}
        transition={TRANSITION}
        _hover={{ bg: FORUM.panelJasny }}
      >
        {expanded ? (
          <FaChevronDown color={FORUM.tekstPrzygaszony} size={11} />
        ) : (
          <FaChevronRight color={FORUM.tekstPrzygaszony} size={11} />
        )}
        <Text fontSize={"sm"} fontWeight={"600"} color={FORUM.tekstJasny} noOfLines={1}>
          {header}
        </Text>
        {person && (
          <Text fontSize={"xs"} color={"#6C99FF"} noOfLines={1}>
            {person.nickname}
          </Text>
        )}
        {moje && (
          <Text fontSize={"10px"} fontWeight={"bold"} color={"#6C99FF"}>
            TWOJE
          </Text>
        )}
        {claimedBy && (
          <Text fontSize={"11px"} color={"#4FB477"} noOfLines={1}>
            wziął: {claimedBy.nickname}
          </Text>
        )}
        <Box flex={1} />
        <Text fontSize={"xs"} color={FORUM.tekstPrzygaszony} whiteSpace={"nowrap"}>
          {done_all}/{wszystkie}
        </Text>
        <Text
          fontSize={"10px"}
          color={assignment.status === "ukonczone" ? "#4FB477" : FORUM.tekstPrzygaszony}
          bg={FORUM.plakietka}
          borderRadius={"full"}
          px={2}
          py={"1px"}
          whiteSpace={"nowrap"}
        >
          {STATUS_NAME[assignment.status] || assignment.status}
        </Text>
      </Flex>

      {expanded && (
        <Box px={3} pb={3}>
          <Flex direction={"column"} gap={1}>
            {assignment.items.map((item) => (
              <Flex key={item.id} align={"flex-start"} gap={2}>
                <Checkbox
                  colorScheme={"green"}
                  isChecked={Boolean(item.done)}
                  onChange={(e) => toggle(item, e.target.checked)}
                  mt={"2px"}
                />
                <Box flex={1} minW={0}>
                  {editedItem === item.id ? (
                    <Input
                      size={"sm"}
                      autoFocus
                      value={draftItem}
                      onChange={(e) => setDraftItem(e.target.value)}
                      onBlur={() => renameItem(item, draftItem)}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") renameItem(item, draftItem);
                        if (e.key === "Escape") setEditedItem(null);
                      }}
                    />
                  ) : (
                    <Text
                      fontSize={"sm"}
                      color={item.done ? FORUM.tekstPrzygaszony : FORUM.tekst}
                      textDecoration={item.done ? "line-through" : "none"}
                    >
                      {item.description}
                    </Text>
                  )}
                  {Boolean(item.done) && Boolean(item.done_by) && (
                    <Text fontSize={"10px"} color={FORUM.tekstPrzygaszony}>
                      odhaczył:{" "}
                      {people.find((o) => String(o.id) === String(item.done_by))?.nickname ||
                        "ktoś"}
                      {item.done_at
                        ? ` · ${new Date(item.done_at).toLocaleDateString("pl-PL", {
                            day: "2-digit",
                            month: "2-digit",
                          })}`
                        : ""}
                    </Text>
                  )}
                  {item.details && (
                    <Text fontSize={"xs"} color={FORUM.tekstPrzygaszony} whiteSpace={"pre-wrap"}>
                      {item.details}
                    </Text>
                  )}
                </Box>
                {canManage && editedItem !== item.id && (
                  <Box
                    as={"button"}
                    onClick={() => {
                      setDraftItem(item.description);
                      setEditedItem(item.id);
                    }}
                    opacity={0.6}
                    transition={TRANSITION}
                    _hover={{ opacity: 1 }}
                    title={"Zmień treść"}
                  >
                    <FaPencilAlt color={"#6C99FF"} size={10} />
                  </Box>
                )}
                <Box
                  as={"button"}
                  onClick={() => remove(item)}
                  opacity={0.6}
                  transition={TRANSITION}
                  _hover={{ opacity: 1 }}
                  title={"Usuń"}
                >
                  <FaTrash color="#E06C6C" size={11} />
                </Box>
              </Flex>
            ))}
          </Flex>

          <Flex gap={3} align={"center"} wrap={"wrap"} mt={3} mb={1}>
            {canManage && (
              <Flex align={"center"} gap={2}>
                <Text fontSize={"xs"} color={FORUM.tekstPrzygaszony} whiteSpace={"nowrap"}>
                  Osoba
                </Text>
                <Select
                  size={"xs"}
                  maxW={"190px"}
                  value={assignment.assigned_to || ""}
                  onChange={(e) => setAssignee(e.target.value)}
                >
                  <option value="">Cały zespół</option>
                  {people.map((o) => (
                    <option key={o.id} value={o.id}>
                      {o.nickname}
                    </option>
                  ))}
                </Select>
              </Flex>
            )}

            {canManage && (
              <Flex align={"center"} gap={2}>
                <Text fontSize={"xs"} color={FORUM.tekstPrzygaszony} whiteSpace={"nowrap"}>
                  Kategoria
                </Text>
                <Select
                  size={"xs"}
                  maxW={"190px"}
                  value={assignment.team}
                  onChange={(e) => moveToCategory(e.target.value)}
                >
                  {CATEGORIES.filter((c) => !c.rconOnly || isRcon()).map((c) => (
                    <option key={c.key} value={c.key}>
                      {c.name}
                    </option>
                  ))}
                </Select>
              </Flex>
            )}

            {canManage && (
              <Flex align={"center"} gap={2}>
                <Text fontSize={"xs"} color={FORUM.tekstPrzygaszony} whiteSpace={"nowrap"}>
                  Termin tej części
                </Text>
                <Input
                  size={"xs"}
                  type={"date"}
                  maxW={"150px"}
                  value={assignment.deadline || ""}
                  onChange={(e) => setDeadline(e.target.value)}
                />
              </Flex>
            )}

            {assignment.kind === "team" && (
              <Box
                as={"button"}
                fontSize={"xs"}
                px={3}
                py={1}
                borderRadius={"md"}
                border={"1px solid"}
                borderColor={claimedByMe ? "rgba(79,180,119,0.5)" : FORUM.obramowanie}
                color={claimedByMe ? "#4FB477" : FORUM.tekst}
                bg={FORUM.tlo}
                transition={TRANSITION}
                _hover={{ borderColor: "#6C99FF", color: FORUM.tekstJasny }}
                onClick={claimedByMe ? release : claim}
                title={
                  claimedBy && !claimedByMe
                    ? `Wziął już ${claimedBy.nickname}`
                    : undefined
                }
                disabled={Boolean(claimedBy) && !claimedByMe}
              >
                {claimedByMe ? "Oddaj zespołowi" : "Biorę na siebie"}
              </Box>
            )}
          </Flex>

          {error && (
            <Text fontSize={"xs"} color={"#F08A80"} mt={2}>
              {error}
            </Text>
          )}

          {canManage && (
            <Flex
              as={"button"}
              align={"center"}
              gap={1.5}
              mt={2}
              px={2}
              py={1}
              borderRadius={"md"}
              border={"1px solid"}
              borderColor={"rgba(224,108,108,0.4)"}
              color={"#E06C6C"}
              transition={TRANSITION}
              _hover={{ bg: "rgba(224,108,108,0.12)", borderColor: "#E06C6C" }}
              onClick={removeAssignment}
            >
              <FaTrash size={10} />
              <Text fontSize={"xs"}>Usuń ten przydział</Text>
            </Flex>
          )}

          <Flex gap={2} mt={2}>
            <Input
              size={"sm"}
              placeholder={"Dopisz rzecz do zrobienia"}
              value={draft}
              onChange={(e) => setNowa(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && add()}
            />
            <Box
              as={"button"}
              px={3}
              borderRadius={"md"}
              bg={FORUM.granat}
              color={FORUM.tekstJasny}
              transition={TRANSITION}
              _hover={{ bg: "#3A4870" }}
              onClick={add}
              disabled={adding || !draft.trim()}
              title={"Dodaj"}
            >
              <FaPlus size={11} />
            </Box>
          </Flex>
        </Box>
      )}
    </Box>
  );
};

export default AssignmentSection;
